export default [
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    
  },
]
